<template>
  <!--
  <div class="p-6 bg-gray-100 max-w-full">
    <h1 class="text-2xl font-bold mb-6">Quiz </h1>
-->
    <div ref="focusDiv" tabindex="0" class="flashCardContainer  pt-6"   @keyup="keyHandler" >
      <h1  class="font-bold text-2xl mb-6 text-blue-600 border-b pb-2">Quiz - Total {{ total }} - Correct {{ correct }}</h1>

      <div class="space-x-2">
 <button @click="submitAnswers" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">

      Submit
	     </button>
	     <button @click="next" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
	       Next
	     </button>

	      <button @click="edit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
	       Edit
	        </button>
	</div>
   <div class="flashcard h-4/5" @click="showSide"  tabindex="0">
    


	   <div class=" rounded overflow-hidden shadow-lg ">
	     <div class="flex justify-center items-center border p-2 rounded h-[512px] w-full">
               <canvas ref="sketchpad" width="500" height="500"></canvas>
	 
	     </div>

	     <div class="px-6 py-4">
	       
	       <div v-if="!showState"> 
		
		 <div class="font-bold text-2xl mb-2" v-html="formattedText"></div>
	       </div>
	       <div v-else-if="showState == true">
		 <div class="font-bold text-2xl mb-2" v-html="formattedBackText" ></div>
	       </div>
	       <p class="text-gray-700 text-base">
		
	       </p>

	      </div> 
	    
	   </div>


	   <div>
	     <input v-model="inputValue" type="text" size="100" class="border p-2 rounded" placeholder="Enter text here">
	   </div>
	   <div>
	     <h1  class="font-bold text-2xl mb-6 text-blue-600 border-b pb-2">Answer: {{ answerReveal }} </h1>
	     </div>
	   <div>
	    
    </div>
   </div>

   
  </div>
</template>

    <script>
import { get_token,backend_post, backend_get} from '@/services/cognito-auth';
import { server } from '@/constants.js';
import * as dermotor from '@/services/dermotor.js';

import QuestionTextInput from './QuestionTextInput.vue';


function replaceTagsWithUnderscores(str, answers) {
  let answerIndex = 0;
  return str.replace(/<a>/g, () => {
    if (answerIndex < answers.length) {
      const underscores = '_'.repeat(answers[answerIndex].length);
      answerIndex++;
      return underscores;
    }
    return "<a>"; // If there are more <a> tags than answers, keep the remaining <a> tags.
  });
}

function arraysMatchExact(arr1, arr2) {
  // First, check if the arrays are of the same length
  if (arr1.length !== arr2.length) return false;

  // Compare each element
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }

  // All elements match
  return true;
}

export function toPlaintext(delta) {
    
    return delta.reduce(function (text, op) {
	if (!op.insert) return ''//throw new TypeError('only `insert` operations can be transformed!');
	if (typeof op.insert !== 'string') return text + ' ';
	return text + op.insert;
    }, '');
};


function shuffle(array) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

export default {
 props: {
	quizId: {
	    type: Number, // or Number, depending on your use case
	    required: false
	}
    },    
    components: {

    QuestionTextInput
  },
  data() {
    return {
      questions: [
        
        // Add more questions as needed
      ],
	selectedAnswers: [],
	showStats: false,
	stats_p: 0,
	quizName: '',
	front: 'Question',
	back: 'Answer',
	    showBack: false,
	showState: 0,
	inputValue: "",
	answer: "",
	correct: 0,
	total: 0,
	cards: [],
	currentCard:0,
	answerReveal: ""

    };
  },
   
  methods: {
    submitAnswers() {
      console.log("Selected Answers:", this.selectedAnswers);
      // Handle the submission logic here, e.g., send answers to the server
    },
      getComponentForQuestionType(type) {
	  return 'QuestionTextInput';
	  /*
	  switch (type) {
	  case 'textInput':
              return 'QuestionTextInput';
	  default:
              return null; // or a default component
	      }
	      */
      },
      next() {
	  this.currentCard += 1
	  this.answerReveal = ""
	  this.loadCard()
      },
      edit() {

	  let card = this.cards[this.currentCard]
	  
	  this.$router.push(`/cards/edit/${card.id}`)
      },
      
      submitAnswers() {
	  console.log("SUBMIT")

	  console.log(this.answer === this.inputValue)
	  console.log(this.answer)

	  if (this.answer === this.inputValue) {

	      this.correct += 1
	  }
	  else {
	      
	  }

	this.answerReveal = this.answer
	      
      },
      async loadCard() {

	  if (this.currentCard + 1 > this.total)
	      return
	  
	  const canvas = this.$refs.sketchpad;
	      var ctx = canvas.getContext("2d");
	  dermotor.clear_rect(ctx)

	  let fq = 50
	  
	let card = this.cards[this.currentCard]
	console.log(card)
	this.front = toPlaintext(card.jsondata.front.ops) //"TEST"
	this.back
	this.inputValue = this.front.split('\n')[0]
	this.answer = toPlaintext(card.jsondata.back.ops).split('\n')[0]
	
	
	  

	  //let card = this.cards[this.currentCard]
	  console.log(card,server)
	  let url = await backend_get(`${server}/cards/image/url/${card.id}`)
	  console.log(url)
	  dermotor.load_image(ctx,canvas,url.data.url)
	  
      },
       keyHandler(e) {
	   console.log(e)
	   }
  
    
  },
    computed: {
	percentageCorrect() {
	    return this.stats_p
	},
	formattedText() {
	    return this.front.replace(/\n/g, '<br>');
	},
	formattedBackText() {
	    return this.back.replace(/\n/g, '<br>');
	},	
    },

    async mounted() {

	console.log("Mounted:",this.quizId)

	let offset = 0//this.currentPage * this.itemsPerPage
	let term = "quiz"
	    let data = await backend_get(`${server}/cards/search/tag?term=${term}&offset=${offset}`)
	    console.log(data)

	this.cards = data.data.cards.slice(0,10)

	shuffle(this.cards)
	this.total = this.cards.length
	this.currentCard = 0
	this.loadCard()

    }
};
</script>

<style scoped>
/* Add any additional styles specific to this component */
</style>
